import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ImportacaoSva } from 'src/app/model/importacaoSva';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ImportacaoSvaService {

  constructor(private http: HttpClient) { }

  findAll(): Observable<ImportacaoSva[]> {
    return this.http.get<ImportacaoSva[]>(`${environment.apiUrl}/importacao-sva`);
  }

  findById(id: number) {
    return this.http.get(`${environment.apiUrl}/importacao-sva/${id}`);
  }

  findByIdExample(id: number) { }

  save(importacaoSva: ImportacaoSva) {
    return this.http.post(`${environment.apiUrl}/importacao-sva`, importacaoSva);
  }

  delete(id: number) {
    return this.http.delete(`${environment.apiUrl}/importacao-sva/${id}`);
  }

  uploadFile(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<string[][]>(`${environment.apiUrl}/importacao-sva/xls`, formData);
  }
}
